import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import Card from "components/Card/Card.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CardBody from "components/Card/CardBody.js";
import api from "utils/API";
import { Link } from "react-router-dom";
import ViewTitle from "views/Widgets/FichaPersonal/viewTitle";
import CardTitle from "views/Widgets/FichaPersonal/cardTitle";
import LoadingSpinner from "views/Widgets/FichaPersonal/loadingSpinner";
import ModalCreateCovenant from "components/Covenants/ModalCreateCovenant";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import { days_open } from "components/Request/ManageRequest/DaysOpen";
import moment from "moment";
import IconButton from "@material-ui/core/IconButton";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";
import InsertInvitationIcon from "@material-ui/icons/InsertInvitation";
import { useHistory } from "react-router-dom";
import OrdersInformation from "./OrdersInformation";
import TableInProcess from "./Tables/TableInProcess";
import TableToOutcome from "./Tables/TableToOutcome";
import TableFinalized from "./Tables/TableFinalized";
import {  setmessageAlert } from "actions/getGlobalAction";

const DEFAULT_TAB_QUERY = { page: 0, pageSize: 25, orderBy: null, orderType: null, columnFilters: {} };
// "Activas" carga 100 de entrada (el tope máximo del backend) para que la ventana
// de "página 1 se auto-actualiza" tenga margen antes de necesitar ir a la página 2.
const DEFAULT_IN_PROCESS_QUERY = { ...DEFAULT_TAB_QUERY, pageSize: 100 };
const TAB_QUERY_DEBOUNCE_MS = 1000;
const SUMMARY_POLL_MS = 300000;

const fetchOrdersPage = (group, estado, query) => {
  const params = new URLSearchParams();
  params.set("page", String(query.page + 1));
  params.set("page_size", String(query.pageSize));
  if (query.orderBy) {
    params.set("ordering", `${query.orderType === "desc" ? "-" : ""}${query.orderBy}`);
  }
  Object.entries(query.columnFilters).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });
  return api
    .get(`api/bodega/pedidos/grupo/${group}/estado/${estado}/?${params.toString()}`)
    .then(response => ({ results: response.data.results, count: response.data.count }));
};

// La ventana en vivo (prepender nuevas, descartar las más antiguas del final) solo
// tiene sentido cuando se está viendo el orden por defecto (más nuevo primero), sin
// filtros de columna que las solicitudes nuevas podrían no cumplir, y en la página 1
// (la página 2 en adelante se carga fresca cuando el usuario navega a ella).
const isDefaultInProcessView = query =>
  query.page === 0 && !query.orderBy && Object.values(query.columnFilters).every(value => !value);

export default function WareHouseOrders() {
  const dispatch = useDispatch();
  const [moduleType] = useState(() => {
    const tempArrayURL = window.location.href.split('/');
    return tempArrayURL[tempArrayURL.length - 1];
  });
  const group = moduleType === "storage" ? "Insumos" : "Medicamentos";
  const actualGroup = moduleType === "storage" ? "insumo" : "farmacia";

  const [queryInProcess, setQueryInProcess] = useState({ ...DEFAULT_IN_PROCESS_QUERY });
  const [queryToOutcome, setQueryToOutcome] = useState({ ...DEFAULT_TAB_QUERY });
  const [queryFinalized, setQueryFinalized] = useState({ ...DEFAULT_TAB_QUERY });

  const [dataInProcess, setDataInProcess] = useState({ results: [], count: 0 });
  const [dataToOutcome, setDataToOutcome] = useState({ results: [], count: 0 });
  const [dataFinalized, setDataFinalized] = useState({ results: [], count: 0 });

  const [ordersSummary, setOrdersSummary] = useState({ esperando: 0, hoy: 0, semana: 0, total: 0 });
  const lastSummaryCheckRef = useRef(null);
  // El poll de 5 min corre en un setInterval creado una sola vez (ver más abajo):
  // necesita leer el query vigente de "Activas" sin quedar atado al closure del
  // render en que se creó el interval, de ahí el ref en vez de leer el state directo.
  const queryInProcessRef = useRef(queryInProcess);
  useEffect(() => {
    queryInProcessRef.current = queryInProcess;
  }, [queryInProcess]);

  const [loading, setLoading] = useState(false);
  const [modal_create_covenant, setModal_create_covenant] = useState(false);
  const [value, setValue] = useState(0);

  const [checkTab, setCheckTab] = useState(0);
  const [visitedOutcome, setVisitedOutcome] = useState(false);
  const [visitedFinalized, setVisitedFinalized] = useState(false);

  const history = useHistory();

  const routeChange = () => {
    let path = `/admin/warehouse/calendar/${moduleType}`;
    history.push(path);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    if (value === 0) {
      setCheckTab(0);
    }
    if (value === 1) {
      setCheckTab(1);
    }
    if (value === 2) {
      setCheckTab(2);
    }

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`
    };
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (value === 1) setVisitedOutcome(true);
    if (value === 2) setVisitedFinalized(true);
  }, [value]);

  // Pestaña "En proceso": pagina/ordena/filtra contra el backend, con debounce
  // para no disparar un request por cada tecla al escribir un filtro de columna.
  useEffect(() => {
    const timer = setTimeout(() => {
      fetchOrdersPage(group, "Activas", queryInProcess).then(data => {
        setDataInProcess(data);
        setLoading(true);
      });
    }, TAB_QUERY_DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [queryInProcess, group]);

  // Pestaña "En espera de egresos": misma lógica, pero solo empieza a pedir datos
  // una vez que el usuario visita la pestaña por primera vez.
  useEffect(() => {
    if (!visitedOutcome) return undefined;
    const timer = setTimeout(() => {
      fetchOrdersPage(group, "Egresos", queryToOutcome).then(setDataToOutcome);
    }, TAB_QUERY_DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [queryToOutcome, visitedOutcome, group]);

  // Pestaña "Finalizado": ídem.
  useEffect(() => {
    if (!visitedFinalized) return undefined;
    const timer = setTimeout(() => {
      fetchOrdersPage(group, "Finalizadas", queryFinalized).then(setDataFinalized);
    }, TAB_QUERY_DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [queryFinalized, visitedFinalized, group]);

  // Tarjetas de resumen + alerta de solicitudes nuevas: se calculan en el backend
  // sobre el total real de "Activas", sin depender del array paginado de la tabla.
  // Si el usuario está viendo la página 1 en el orden por defecto (sin filtros), las
  // solicitudes nuevas se insertan al inicio de la lista ya cargada y se descartan
  // esa misma cantidad desde el final, para que la página 1 quede siempre al día sin
  // recargar todo; la página 2 en adelante ignora este parche y se carga fresca al
  // navegar a ella.
  const fetchOrdersSummary = () => {
    const params = new URLSearchParams();
    if (lastSummaryCheckRef.current) {
      params.set("nuevas_desde", lastSummaryCheckRef.current);
    }
    const checkTimestamp = new Date().toISOString();
    api.get(`api/bodega/pedidos/grupo/${group}/estado/Activas/resumen/?${params.toString()}`).then(response => {
      const { esperando, hoy, semana, total, nuevas } = response.data;
      setOrdersSummary({ esperando, hoy, semana, total });

      if (lastSummaryCheckRef.current === null) {
        if (total > 0) {
          setmessageAlert(dispatch, `Tiene ${total} solicitudes que requieren su atención`, "success");
        }
      } else if (nuevas && nuevas.length > 0) {
        const ids = nuevas.reduce((accum, obj) => `${accum}, ${obj.id}`, "");
        setmessageAlert(dispatch, `Tiene ${nuevas.length} solicitudes nuevas que requieren su atención (${ids})`, "success");

        if (isDefaultInProcessView(queryInProcessRef.current)) {
          fetchOrdersPage(group, "Activas", { ...DEFAULT_TAB_QUERY, pageSize: nuevas.length }).then(freshData => {
            setDataInProcess(prev => ({
              results: [...freshData.results, ...prev.results].slice(0, prev.results.length),
              count: freshData.count
            }));
          });
        }
      }
      lastSummaryCheckRef.current = checkTimestamp;
    });
  };

  useEffect(() => {
    fetchOrdersSummary();
    const interval = setInterval(fetchOrdersSummary, SUMMARY_POLL_MS);
    return () => clearInterval(interval);
  }, [group]);

  const months_open = date => {
    const today = moment(new Date()).format("DD/MM/YYYY");
    const request_date = moment(date).format("DD/MM/YYYY");
    const diff = moment(today, "DD/MM/YYYY").diff(
      moment(request_date, "DD/MM/YYYY")
    );
    const duration = moment.duration(diff);
    return duration._data.months;
  };

  const buildTabTableProps = (query, setQuery, data) => ({
    data: data.results,
    totalCount: data.count,
    page: query.page,
    rowsPerPage: query.pageSize,
    onChangePage: newPage => setQuery(prev => ({ ...prev, page: newPage })),
    onChangeRowsPerPage: newSize => setQuery(prev => ({ ...prev, pageSize: newSize, page: 0 })),
    orderBy: query.orderBy,
    orderType: query.orderType,
    onOrderChange: field =>
      setQuery(prev => ({
        ...prev,
        orderBy: field,
        orderType: field === prev.orderBy ? (prev.orderType === "asc" ? "desc" : "asc") : "asc",
        page: 0
      })),
    columnFilters: query.columnFilters,
    onColumnFilterChange: (field, filterValue) =>
      setQuery(prev => ({
        ...prev,
        columnFilters: { ...prev.columnFilters, [field]: filterValue },
        page: 0
      })),
    moduleType,
    months_open,
    days_open,
    actualGroup
  });

  return (
    <GridContainer>
      <ViewTitle
        title="PEDIDOS"
        message={`En esta sección podrás revisar los pedidos de ${moduleType === "storage" ? "bodega" : "bodega farmacia"}.`}
      />
      <GridItem xs={12} sm={6} md={12}>
        <CardBody className="rounded shadow border border-primary">
          <Breadcrumbs aria-label="breadcrumb">
            <Typography color="textPrimary">Operaciones</Typography>
            <Link color="inherit" to={`/admin/warehouse/task/${moduleType}`}>
            {`Tareas ${moduleType === "storage" ? "Bodega" : "Bodega Farmacia"}`}
            </Link>
            <Typography color="textPrimary">Pedidos</Typography>
            {checkTab === 0 ? (
              <Typography color="textPrimary">En proceso</Typography>
            ) : checkTab === 1 ? (
              <Typography color="textPrimary">En espera de egresos</Typography>
            ) : (
              <Typography color="textPrimary">Finalizado</Typography>
            )}
          </Breadcrumbs>
        </CardBody>
      </GridItem>
      <GridItem xs={12} sm={6} md={12}>
        {loading ? (
          <Card>
            <GridContainer justify="center" className="mt-3">
              <GridContainer justify="center">
                <OrdersInformation
                  itemWait={ordersSummary.esperando}
                  itemToDay={ordersSummary.hoy}
                  itemWeek={ordersSummary.semana}
                  total={ordersSummary.total}
                />
              </GridContainer>
            </GridContainer>
            <GridItem
              container
              direction="row"
              justify="flex-end"
              alignItems="center"
            >
              <IconButton
                onClick={routeChange}
                color="primary"
                aria-label="add to shopping cart"
              >
                <InsertInvitationIcon style={{ fontSize: 50 }} />
              </IconButton>
            </GridItem>
            <CardBody className="mb-1">
              <AppBar position="static">
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="simple tabs example"
                  centered
                >
                  <Tab
                    style={{ textTransform: "none" }}
                    label="En proceso"
                    {...a11yProps(0)}
                  />
                  <Tab
                    style={{ textTransform: "none" }}
                    label="En espera de egresos"
                    {...a11yProps(1)}
                  />
                  <Tab
                    style={{ textTransform: "none" }}
                    label="Finalizado"
                    {...a11yProps(3)}
                  />
                </Tabs>
              </AppBar>
              <TabPanel value={value} index={0}>
                <TableInProcess {...buildTabTableProps(queryInProcess, setQueryInProcess, dataInProcess)} />
              </TabPanel>

              <TabPanel value={value} index={1}>
                <TableToOutcome {...buildTabTableProps(queryToOutcome, setQueryToOutcome, dataToOutcome)} />
              </TabPanel>

              <TabPanel value={value} index={2}>
                <TableFinalized {...buildTabTableProps(queryFinalized, setQueryFinalized, dataFinalized)} />
              </TabPanel>
            </CardBody>
          </Card>
        ) : (
          <Card>
            <CardTitle title="Cargando información ..." />
            <CardBody className="d-flex justify-content-center">
              <LoadingSpinner />
            </CardBody>
          </Card>
        )}
      </GridItem>
      {modal_create_covenant && (
        <ModalCreateCovenant
          open={modal_create_covenant}
          closeModal={() => setModal_create_covenant(false)}
        />
      )}
    </GridContainer>
  );
}
